import * as z from 'helpers/zod'
import { AVAILABLE_LOCALES, AVAILABLE_CURRENCIES } from 'types/localisation'

export const siteSettingsSchema = z.object({
  location: z.string(),
  locale: z.enum(AVAILABLE_LOCALES),
  currency: z.enum(AVAILABLE_CURRENCIES)
})

export type SiteSettingsSchemaProps = z.infer<typeof siteSettingsSchema>
